import { library, dom } from '@fortawesome/fontawesome-svg-core'

// Regular icons
import {
    faAngleLeft,
    faAngleRight,
    faEnvelope,
    faPhone,
    faCalendarCheck,
    faCheck,
    faInfo,
    faExclamation,
    faTimes,
    faChevronUp,
    faChevronDown,
    faShoppingBag,
    faSearch,
    faExternalLink,
    faBars,
    faAddressCard,
    faGem,
    faDiagnoses,
    faLeaf,
    faMapMarker,
    faThumbsUp,
    faSmile
} from '@fortawesome/pro-regular-svg-icons'

// Solid icons
import {
    faCircle,
    faTag,
    faStar
} from '@fortawesome/pro-solid-svg-icons'

// Brand icons
import { faFacebookF, faYoutube, faGooglePlusG, faTwitter, faPinterestP, faInstagram } from '@fortawesome/free-brands-svg-icons'

// Add imported icons to the library
library.add(
    faAngleLeft, faAngleRight, faEnvelope, faPhone, faCalendarCheck, faCheck, faInfo, faExclamation, faTimes, faChevronUp,
    faChevronDown, faShoppingBag, faSearch, faExternalLink, faBars, faAddressCard, faGem,
    faDiagnoses,
    faLeaf,
    faMapMarker,
    faThumbsUp,
    faSmile,

    faCircle, faTag, faStar,

    faFacebookF, faYoutube, faGooglePlusG, faTwitter, faPinterestP, faInstagram
)

// Kicks off the process of finding <i> tags and replacing with <svg>
dom.watch()


// WEBPACK FOOTER //
// ./Private/JavaScript/Component/FontAwesome.js